import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const ITEMS = [
  "Entendimento da necessidade.",
  "Escopo do serviço definido.",
  "Orçamento apresentado antes da contratação.",
  "Condições de execução e garantia esclarecidas.",
];

export default function ParaQuem() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          index="06"
          label="Transparência"
          title="Um atendimento transparente do início ao fim."
          lead="Cada instalação possui características próprias. Por isso, antes de iniciar qualquer serviço, a HidroPro Serviços Técnicos busca entender sua necessidade e apresentar as informações necessárias para uma contratação segura."
        />
        <div data-testid="hidropro-transparency-section" className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item} delay={i * 0.08} className="h-full">
              <div className="flex h-full items-start gap-3 rounded-xl border border-[rgba(10,92,140,0.14)] bg-paper p-5 transition-all duration-300 hover:border-[#0A5C8C]/45 hover:shadow-[0_14px_34px_rgba(10,92,140,0.12)]">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0A5C8C] text-white">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <p className="text-sm font-medium leading-relaxed text-[#1A1A1A]">{item}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
